import React from 'react'
import ChooseAuth from '../../components/auth/ChooseAuth'

const SignupOpt = () => {
  return (
    <div>
        <ChooseAuth />
    </div>
  )
}

export default SignupOpt